<!--日历组件，创建广告时，当按天投放控制选择加速投放时，显示日历，即为该组件-->
<template>
  <transition name="slide">
    <div>
      <div class="calendar-button" @click="showCalPanel">显示日历</div>
      <transition name="slide">
        <div class="calendar-panel" v-show="showCal">
          <div class="cal-header clearfix">
            <span class="yearBox fl">{{year}}年</span>
            <span class="changeMonth fr" @click="changeMonth(1)">
              <i class="icon iconfont icon-right1"></i>
            </span>
            <span class="changeMonth fr" @click="changeMonth(-1)">
              <i class="icon iconfont icon-left"></i>
            </span>
            <span class="month fr">{{month}}月</span>
          </div>
          <table class="dateTable" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th v-for="(week, weekIndex) in weeks" :key="weekIndex">{{week}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cell, cellIndex) in calendar" :key="cellIndex">
                <td v-for="(item, index) in cell" :key="index">
                  <span
                    :class="{'disableDate': disabledDate(item.data) || (parseInt(item.month) !== month)}"
                  >{{item.day}}</span>
                  <input
                    class="numBox"
                    type="text"
                    v-model="num[item.data]"
                    v-if="!disabledDate(item.data) && getUnCurMonth(item.month)"
                    @change="changeNum(item.data)"
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="operateNum">
            <el-input v-model="sameNum" class="inputBox" @change="batchOpr">
              <template slot="append">
                <span>/天</span>
                <strong>批量</strong>
              </template>
            </el-input>
            <span class="commitBtn" @click="commitNum">确定</span>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { getAllGapDate } from "../util/date.js"
import vue from 'vue'
export default {
  props: {
    date: {
      type: String,
      default: ''
    },
    dateArr: {  // 将已选择的投放周期期传递到本日历组件
      type: Array,
      default: function () {
        return []
      }
    },
    numData: {  // 加速投放时，对应日期填写的投放量
      type: Object,
      default: function () {
        return {}
      }
    },
    noEvenSpeed: { // 传递当前按天投放控制的值，是否选择加速投放
      type: Boolean,
      default: true
    },
    disabledPage: {  // 是否禁用
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      calendar: [],
      year: '',
      month: '',
      current: '',
      select: '',
      activeColor: '',
      num: {},
      showCal: false,
      hasValue: false,
      sameNum: '', // 批量次数
      unCurMonth: false
    };
  },
  created () {
    this.showCalendar();
    this.setNum();
  },
  methods: {
    // 输出一个日历数据源  月份不必减1
    getCalendar (y, m) {
      y = parseInt(y);
      m = parseInt(m);
      let time = new Date(y, m - 1, 1);
      let lastDate, nextDate;
      let lastMonth = m - 1;
      let nextMonth = m + 1;
      if (m == 1) {
        lastDate = '' + (y - 1) + '-' + +12 + '-';
        nextDate = '' + y + '-' + 2 + '-';
        lastMonth = 12;
      } else if (m == 12) {
        lastDate = '' + y + '-' + 11 + '-';
        nextDate = '' + (y + 1) + '-' + 1 + '-';
        nextMonth = 1;
      } else {
        lastDate = '' + y + '-' + (m - 1) + '-';
        nextDate = '' + y + '-' + (m + 1) + '-';
      }
      let maxNumber = 42;
      let r1 = []; let r2 = []; let r3 = [];
      let lastFix = time.getDay() - 1;
      lastFix = lastFix < 0 ? lastFix + 7 : lastFix;
      let lastMaxDate = new Date(y, m - 1, 0).getDate(); // 上个月份最大天数
      let maxDate = new Date(y, m, 0).getDate(); // 当前月份的
      let i, t;
      for (i = 0; i < lastFix; i++) {
        t = lastMaxDate - lastFix + i + 1;
        r1[i] = { month: lastMonth, day: t, data: lastDate + t };
      }
      for (i = 0; i < maxDate; i++) {
        t = i + 1;
        r2[i] = { month: m, day: t, data: '' + y + '-' + +m + '-' + t };
        if (m > 0 && m < 10) {
          m = '0' + (m++);
        }
        if (t > 0 && t < 10) {
          t = '0' + t;
        }
        r2[i].data = '' + y + '-' + m + '-' + t;
      }
      let nextFix = maxNumber - maxDate - lastFix;
      for (i = 0; i < nextFix; i++) {
        t = i + 1;
        r3[i] = { month: nextMonth, day: t, data: nextDate + t };
      }
      let result = r1.concat(r2, r3);
      let ar = [];
      for (i = 0; i < 6; i++) {
        ar.push(result.splice(0, 7));
      }
      return ar;
    },
    showCalendar () {
      let day = ''; // 用于显示日历的日期
      // 验证是否是父组件传来的日期
      if (!this.date || this.date.length < 1) {
        day = new Date();
      } else {
        let outDate = this.date.split('-');
        day = new Date(outDate[0], outDate[1] - 1, outDate[2]);
      }
      // 验证日期是否有效
      if (Object.prototype.toString.call(day) === '[object Date]') {
        if (isNaN(day.getTime())) {
          day = new Date();
        } else {
          this.select = day.getFullYear() + '-' + (day.getMonth() + 1) + '-' + day.getDate();
        }
      } else {
        day = new Date();
      }
      // 获取当前的日期 并格式化 'YY-MM-DD'
      let curDate = new Date();
      this.current = '' + curDate.getFullYear() + '-' + (curDate.getMonth() + 1) + '-' + curDate.getDate();
      this.year = day.getFullYear();
      this.month = day.getMonth() + 1;
      // this.month = this.month < 10 ? '0' +  this.month :  this.month
      this.calendar = this.getCalendar(this.year, this.month);
    },
    // 选择了的日期
    selectDate (date, flag1, flag2) {
      if (flag1) {
        return;
      }
      if (flag2) {
        return;
      }
      this.select = date;
      this.$emit('selected', this.patchZero(date));
    },
    changeMonth (flag) {
      if (flag == -1) {
        if (this.month == 1) {
          this.init(parseInt(this.year) - 1, 12);
        } else {
          this.init(this.year, parseInt(this.month) - 1);
        }
      } else {
        if (this.month == 12) {
          this.init(parseInt(this.year) + 1, 1);
        } else {
          this.init(this.year, parseInt(this.month) + 1);
        }
      }
    },
    init (y, m) {
      // 切换日历
      this.calendar = this.getCalendar(y, m);
      this.year = y;
      this.month = m;
    },
    // 补 0 操作
    patchZero (date) {
      let y = new Date(date).getFullYear();
      let m = new Date(date).getMonth() + 1;
      let d = new Date(date).getDate();
      m < 10 && (m = '0' + m);
      d < 10 && (d = '0' + d);
      return y + '-' + m + '-' + d;
    },
    //
    disabledDate (time) {
      let flag = false;
      let year = time.split('-')[0];
      let month = time.split('-')[1];
      let day = time.split('-')[2];
      month = parseInt(month) < 10 ? '0' + parseInt(month) : month;
      day = parseInt(day) < 10 ? '0' + parseInt(day) : day;
      let date = year + '-' + month + '-' + day;
      date = (new Date(date)).getTime();
      return !this.dateArr.some(item => {
        let date1 = (new Date(item[0])).getTime();
        let date2 = (new Date(item[1])).getTime();
        flag = !(date >= date1 && date <= date2) || date < (new Date()).getTime() - 8.64e7;
        return !flag;
      });
    },
    // 非当月 不可操作
    getUnCurMonth (m) {
      m = parseInt(m);
      let newMonth = this.month;
      newMonth = newMonth < 10 ? parseInt('0' + newMonth) : newMonth;
      return m === newMonth;
    },
    //
    changeNum () {
      this.sameNum = '';
    },
    batchOpr () {
      let newDateRange = [];
      this.dateArr.forEach((v) => {
        newDateRange.push(...(getAllGapDate(v[0], v[1])));
      });
      newDateRange = this.uniq(newDateRange);
      newDateRange.forEach((d, j) => {
        vue.set(this.num, d, this.sameNum);
      });
    },
    commitNum () {
      if (this.disabledPage) {
        this.$message('不可编辑！');
        return;
      }
      if (this.isEmpty()) { return; }
      this.showCal = false;
      this.$emit('allNum', this.num);
    },
    uniq (array) {
      let temp = [];
      let index = [];
      let l = array.length;
      for (let i = 0; i < l; i++) {
        for (let j = i + 1; j < l; j++) {
          if (array[i] === array[j]) {
            i++;
            j = i;
          }
        }
        temp.push(array[i]);
        index.push(i);
      }
      return temp;
    },
    isEmpty () {
      let flag = false;
      let newDateRange = [];
      this.dateArr.forEach((v) => {
        newDateRange.push(...(getAllGapDate(v[0], v[1])));
      });
      newDateRange = this.uniq(newDateRange);
      newDateRange.some((d, j) => {
        if (this.noEvenSpeed && (this.num[d] === '' || !this.num[d])) {
          flag = true;
          this.$confirm('请输入按天投放控制！', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            callback: () => {
            },
            type: 'warning'
          });
        }
      });
      return flag;
    },
    setNum () {
      if (this.$route.params.id) {
        for (let v in this.numData) {
          vue.set(this.num, v, this.numData[v]);
        }
      }
    },
    showCalPanel () {
      if (this.dateArr.length < 1) {
        this.$confirm('请选择推广周期！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          callback: () => {
          },
          type: 'warning'
        });
        return;
      }
      this.showCal = true;
    }
  },
  watch: {
    dateArr () {
      this.dateArr = this.dateArr;
    },
    numData () {
      this.setNum();
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
.calendar-button {
  width: 100px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background: #3dc1c4;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
}
.calendar-button:hover {
  background: #17b8c4;
}
.calendar-panel {
  width: 546px;
  padding: 0 25px;
  height: 554px;
  border-top: 5px solid #0e1922;
  box-shadow: 2px 2px 18px -1px #ccc;
  margin-top: 15px;
  .cal-header {
    width: 100%;
    height: 50px;
    line-height: 50px;
    .yearBox {
      font-size: 20px;
    }
    .month {
      font-size: 20px;
      margin-right: 20px;
    }
    .changeMonth {
      width: 30px;
      height: 30px;
      line-height: 26px;
      text-align: center;
      border-radius: 5px;
      background: #ebebeb;
      color: #606060;
      font-size: 20px;
      cursor: pointer;
      margin-left: 6px;
      margin-top: 10px;
    }
    .changeMonth:hover {
      color: #fff;
      background: #4fc0c5;
    }
  }
  table {
    border-bottom: 1px solid #ccc;
    th {
      width: 78px;
      height: 50px;
    }
    td {
      height: 62px;
      margin: 10px 0;
      text-align: center;
      color: #1b1a1a;
      span {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .numBox {
      display: inline-block;
      width: 70px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 10px;
      border: 1px solid #4fc0c5;
      color: #676767;
    }
  }
  .operateNum {
    padding: 22px 0;
    .inputBox {
      width: 165px;
      height: 25px !important;
      border: 1px solid #ccc;
      border-radius: 15px;
      input {
        height: 25px !important;
        border-radius: 15px 0 0 15px;
        width: 70px;
        border: none !important;
        padding: 0 10px;
      }
    }
    .el-input-group__append {
      width: 70px;
      border-radius: 0 15px 15px 0;
      border: none !important;
      background: transparent;
      padding: 0;
      margin: 0;
      height: 25px !important;
      color: #0e1922;
      span {
        float: left;
        height: 25px;
        line-height: 25px;
      }
      strong {
        float: right;
        width: 44px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: #d4d4d4;
        border-radius: 0 15px 15px 0;
        margin-right: 0;
        cursor: pointer;
        font-weight: normal;
      }
    }
    .commitBtn {
      float: right;
      width: 60px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 5px;
      font-size: 14px;
      background: #4fc0c5;
      color: #fff;
      cursor: pointer;
    }
  }
  .disableDate {
    color: #bebbbb;
  }
}
</style>
